import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "../../App.js";
// @ts-ignore
import VerificationOption from "../sections/VerificationOption";
import ProductDetail from "../sections/ProductDetail";

const PageRoutes = (props) => {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="" element={<App />} />
                    <Route path="verify-product" element={<VerificationOption />} />
                    <Route path="product-detail" element={<ProductDetail />} />
                </Routes>
            </BrowserRouter>
        </>
    );
};

export default PageRoutes; 
